/**
 * Section: Blog filters
 * ------------------------------------------------------------------------------
 * Blog filters swiper on mobile
 *
 * @namespace blogFilters
*/
import { register } from '@shopify/theme-sections';
import { values as breakpoints } from '~/helpers/breakpoints';
import Carousel from '~/components/carousel';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-blog-filters="carousel"]',
  cell: '[js-blog-filters="slide"]',
  prevButton: '[js-blog-filters="prev"]',
  nextButton: '[js-blog-filters="next"]'
};
/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 */

register('blog-filters', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors() {
    const container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    const cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    const prevButton = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.prevButton);
    const nextButton = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.nextButton);
    this.cache = {
      container,
      cells,
      nextButton,
      prevButton
    };
  },

  /**
   * Check if the section has enabled the slider option.
   * @returns {Boolean}
   */
  isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel() {
    Carousel(this.cache.container, {
      swiper: {
        // Responsive breakpoints
        breakpoints: {
          [breakpoints.small]: {
            loop: false,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 32
          },
          [breakpoints.large]: {
            loop: false,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 56
          }
        },
        // Default parameters
        loop: false,
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 16
      }
    }).init();
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }

});